import { render, staticRenderFns } from "./VuesticPreLoader.vue?vue&type=template&id=ef468bb4"
import script from "./VuesticPreLoader.vue?vue&type=script&lang=js"
export * from "./VuesticPreLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-preloader/VuesticPreLoader.vue
// module id = 9xHH
// module chunks = 41